import {
  Calendar,
  CalendarClock,
  CalendarDays,
  CalendarRange,
} from 'lucide-react';
import type { PayCycle } from '../../../lib/payPeriod';
import { ChoiceCard } from '../ChoiceCard';
import { StepLayout } from '../StepLayout';
import type { OnboardingDraft } from '../types';

type Props = {
  draft: OnboardingDraft;
  setDraft: (patch: Partial<OnboardingDraft>) => void;
  onContinue: () => void;
  canContinue: boolean;
};

const cycles: Array<{
  value: PayCycle;
  label: string;
  description: string;
  icon: typeof CalendarDays;
}> = [
  {
    value: 'weekly',
    label: 'Weekly',
    description: 'Every 7 days',
    icon: CalendarDays,
  },
  {
    value: 'biweekly',
    label: 'Biweekly',
    description: 'Every 2 weeks',
    icon: CalendarRange,
  },
  {
    value: 'semimonthly',
    label: 'Semi-monthly',
    description: 'Twice a month',
    icon: CalendarClock,
  },
  {
    value: 'monthly',
    label: 'Monthly',
    description: 'Once a month',
    icon: Calendar,
  },
];

export function PayCycleStep({
  draft,
  setDraft,
  onContinue,
  canContinue,
}: Props) {
  return (
    <StepLayout
      icon={<CalendarDays size={28} strokeWidth={1.5} />}
      title="How do you get paid?"
      description="We'll line your daily allowance up with the way money lands."
      onContinue={onContinue}
      canContinue={canContinue}
    >
      <div className="grid grid-cols-2 gap-card-gap">
        {cycles.map((c) => {
          const Icon = c.icon;
          return (
            <ChoiceCard
              key={c.value}
              icon={<Icon size={22} strokeWidth={1.5} />}
              title={c.label}
              description={c.description}
              selected={draft.payCycle === c.value}
              onClick={() => setDraft({ payCycle: c.value })}
              layout="tile"
            />
          );
        })}
      </div>
    </StepLayout>
  );
}
